/*
 * The desktop bar's size control. A custom dropdown rather than a native
 * select, because the options carry the same rows as the mobile sheet:
 * sold out sizes are struck through and offer "notify me" instead of being
 * selectable.
 *
 * It owns opening, closing and which row is chosen; the caller keeps the
 * price, add to cart and wishlist in step through the callbacks.
 */ export const initVariantDropdown = (section, handlers)=>{
    const root = section.querySelector('.js-gift-sets-pdp-details-dropdown');
    const trigger = section.querySelector('.js-gift-sets-pdp-details-dropdown-trigger');
    const panel = section.querySelector('.js-gift-sets-pdp-details-dropdown-panel');
    const label = section.querySelector('.js-gift-sets-pdp-details-dropdown-label');
    if (!root || !trigger || !panel || !label) {
        return null;
    }
    const cleanups = [];
    let isOpen = false;
    let selectedVariantId = null;
    const close = ()=>{
        var _handlers_onClose;
        if (!isOpen) {
            return;
        }
        isOpen = false;
        panel.hidden = true;
        root.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        (_handlers_onClose = handlers.onClose) === null || _handlers_onClose === void 0 ? void 0 : _handlers_onClose.call(handlers);
    };
    const open = ()=>{
        if (isOpen) {
            return;
        }
        isOpen = true;
        panel.hidden = false;
        root.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
    };
    const on = (el, type, handler)=>{
        el.addEventListener(type, handler);
        cleanups.push(()=>el.removeEventListener(type, handler));
    };
    on(trigger, 'click', ()=>{
        if (isOpen) {
            close();
        } else {
            open();
        }
    });
    // Anything outside the control closes it, the way a native select behaves.
    const handleDocumentPointerDown = (event)=>{
        if (!isOpen) {
            return;
        }
        if (!root.contains(event.target)) {
            close();
        }
    };
    const handleDocumentKeyDown = (event)=>{
        if (!isOpen || event.key !== 'Escape') {
            return;
        }
        close();
        trigger.focus();
    };
    document.addEventListener('pointerdown', handleDocumentPointerDown);
    document.addEventListener('keydown', handleDocumentKeyDown);
    cleanups.push(()=>{
        document.removeEventListener('pointerdown', handleDocumentPointerDown);
        document.removeEventListener('keydown', handleDocumentKeyDown);
    });
    const optionName = ()=>root.dataset.optionName || 'size';
    /*
   * Every row is selectable, sold out ones included: choosing one of those
   * turns the add to cart button into the notify control rather than opening
   * anything straight away. The caller decides which, off the variant.
   */ const rows = Array.from(panel.querySelectorAll('.GiftSetsPdpVariantList-button'));
    rows.forEach((button)=>{
        on(button, 'click', ()=>{
            const variantId = Number(button.dataset.variantId);
            if (!Number.isFinite(variantId)) {
                return;
            }
            selectedVariantId = variantId;
            rows.forEach((row)=>row.removeAttribute('aria-current'));
            button.setAttribute('aria-current', 'true');
            var _button_dataset_variantTitle;
            label.textContent = `${optionName()}: ${(_button_dataset_variantTitle = button.dataset.variantTitle) !== null && _button_dataset_variantTitle !== void 0 ? _button_dataset_variantTitle : ''}`;
            handlers.onSelect(variantId);
            close();
            trigger.focus();
        });
    });
    return {
        selectedVariantId: ()=>selectedVariantId,
        optionName,
        open,
        focus: ()=>trigger.focus(),
        cleanup: ()=>{
            close();
            cleanups.forEach((cleanup)=>cleanup());
        }
    };
};
